import React, { lazy, Suspense, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../components/Layout";
import Subscription from "../component/subscription";
import LandingPage from "../pages/LandingPage";
import Plans from "../pages/Plan";
import OAuthCallbackPage from "../pages/auth-callback";
import AuthExternalRedirect from "../pages/auth-external-redirect";

// Lazy load all remote routes
window.__POWERED_BY_HOST__ = true;
// window.__TOKEN__ = localStorage.getItem("token");
const CasebaseApp = React.lazy(() =>
  import("casebase/App").catch((err) => {
    console.error("Error loading casebase:", err);
    return {
      default: () => (
        <div style={{ padding: "40px", textAlign: "center" }}>
          Failed to load Casebase service.
        </div>
      ),
    };
  })
);
const LawbaseApp = React.lazy(() =>
  import("lawbase/App").catch((err) => {
    console.error("Error loading lawbase:", err);
    return {
      default: () => (
        <div style={{ padding: "40px", textAlign: "center" }}>
          Failed to load Lawbase service.
        </div>
      ),
    };
  })
);
// const ContractdbApp = React.lazy(() =>
//   import("contractdb/App").catch((err) => {
//     console.error("Error loading contractdb:", err);
//     return { default: () => <div>Failed to load ContractDB service.</div> };
//   })
// );

function AppRoutes() {
  return (
    <Routes>
      {/* Host landing page */}
      <Route
        path="/"
        element={
          <Layout>
            <LandingPage />
          </Layout>
        }
      />

      {/* Mount all remote routes under /casebase/* - wildcard catches all nested routes */}

      <Route
        path="/casebase/*"
        element={
          <Suspense>
            <Layout>
              <CasebaseApp />
            </Layout>
          </Suspense>
        }
      />

      <Route
        path="/lawbase/*"
        element={
          <Suspense>
            <Layout>
              <LawbaseApp />
            </Layout>
          </Suspense>
        }
      />

      <Route
        path="/pricing"
        element={
          <Layout>
            <Plans />
          </Layout>
        }
      />

      <Route
        path="/subscription"
        element={
          <Layout>
            <Subscription />
          </Layout>
        }
      />

      <Route
        path="/plans"
        element={
          <Layout>
            <Plans />
          </Layout>
        }
      />

      <Route path="/auth/callback" element={<OAuthCallbackPage />} />
      <Route path="/auth-external-redirect" element={<AuthExternalRedirect />} />

      {/* <Route
        path="/contractdb/*"
        element={
          <Suspense>
            <Layout>
              <ContractdbApp />
            </Layout>
          </Suspense>
        }
      /> */}
    </Routes>
  );
}

export default AppRoutes;
